import { ActivityTypesUIProvider } from "./ActivityTypesUIContext";
import { ActivityTypesCard } from "./ActivityTypesCard";

export function ActivityTypesPage({ history }) {
  const activityTypesUIEvents = {
    openNewActivityTypePage: () => {
      history.push("/faaliyet-turleri/ekle");
    },
    openEditActivityTypePage: (id) => {
      history.push(`/faaliyet-turleri/duzenle/${id}`);
    },
  };
  
  return (
    <ActivityTypesUIProvider activityTypesUIEvents={activityTypesUIEvents}>
      <ActivityTypesCard />
    </ActivityTypesUIProvider>
 );
}